"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldErrorSection = void 0;
const react_1 = __importDefault(require("react"));
const FieldErrorSection = (props) => {
    const { errorMessage, assistiveText, required } = props;
    return (react_1.default.createElement(react_1.default.Fragment, null, errorMessage ? (react_1.default.createElement("p", { className: "error-text small" }, errorMessage)) : (react_1.default.createElement("p", { className: "assistive-text small" }, assistiveText !== undefined ? assistiveText : required ? 'Required' : 'Optional'))));
};
exports.FieldErrorSection = FieldErrorSection;
